import axios from "../../axiosConfig";

const API = "/api";

function filenameFromDisposition(header, fallback) {
  const star = /filename\*=UTF-8''([^;]+)/i.exec(header || "");
  const plain = /filename="([^"]+)"/i.exec(header || "");
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1]);
    } catch {
      return star[1];
    }
  }
  if (plain?.[1]) return plain[1];
  return fallback;
}

async function errorDetail(err, fallback) {
  let detail = err?.response?.data?.detail || err?.message || fallback;
  if (err?.response?.data instanceof Blob) {
    try {
      const parsed = JSON.parse(await err.response.data.text());
      detail = parsed.detail || parsed.message || detail;
    } catch {
      /* keep */
    }
  }
  return typeof detail === "string" ? detail : detail?.message || fallback;
}

export async function downloadLibraryFile(url, fallbackName) {
  const res = await axios.get(url, { responseType: "blob" });
  const name = filenameFromDisposition(res.headers?.["content-disposition"], fallbackName);
  const objectUrl = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
  return name;
}

export function downloadOriginalRfp(jobId, fallbackName) {
  return downloadLibraryFile(`${API}/rfp-jobs/${jobId}/source`, fallbackName || "rfp.pdf");
}

export function downloadComplianceExcel(jobId, fallbackName) {
  return downloadLibraryFile(
    `${API}/rfp-download/${jobId}/compliance-excel`,
    fallbackName || "compliance.xlsx"
  );
}

export { errorDetail };
